import { Close } from '@mui/icons-material';
import { Box, Collapse, Grid2, IconButton, Paper, styled, SwipeableDrawer, useMediaQuery } from '@mui/material';
import { grey } from '@mui/material/colors';
import { Title } from '@utriper/core-ui';

const Puller = styled('div')(({ theme }) => ({
    width: 30,
    height: 6,
    backgroundColor: grey[900],
    borderRadius: 3,
    position: 'absolute',
    top: 16,
    left: 'calc(50% - 15px)',
}));

const Content = ({ title, handleToggle, children }) => (
    <Box p={2}>
        <Grid2 container justifyContent="space-between" alignItems="center">
            <Title value={title} size="l" styles={{ color: '#363740' }} />
            <IconButton onClick={handleToggle}>
                <Close />
            </IconButton>
        </Grid2>
        <Grid2 container justifyContent="center" alignItems="center">
            {children}
        </Grid2>
    </Box>
);

const ResponsivePanel = ({ open = false, handleToggle = () => {}, title = '', children = '' }) => {
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));

    return isMobile ? (
        <SwipeableDrawer
            anchor="bottom"
            open={open}
            onOpen={handleToggle}
            onClose={handleToggle}
            swipeAreaWidth={56}
            disableSwipeToOpen={false}
            keepMounted
            slotProps={{
                paper: {
                    elevation: 1,
                    sx: { borderTopLeftRadius: '1rem', borderTopRightRadius: '1rem' },
                },
            }}>
            <Puller />
            <Content title={title} handleToggle={handleToggle}>
                {children}
            </Content>
        </SwipeableDrawer>
    ) : (
        <Collapse in={open} unmountOnExit>
            <Paper elevation={1} sx={{ border: '1px solid #e0e0e0' }}>
                <Content title={title} handleToggle={handleToggle}>
                    {children}
                </Content>
            </Paper>
        </Collapse>
    );
};

export default ResponsivePanel;
